import { render, staticRenderFns } from "./waitting-result.vue?vue&type=template&id=7d7c5d56&scoped=true&"
import script from "./waitting-result.vue?vue&type=script&lang=js&"
export * from "./waitting-result.vue?vue&type=script&lang=js&"
import style0 from "./waitting-result.vue?vue&type=style&index=0&id=7d7c5d56&scoped=true&lang=css&"
import style1 from "./waitting-result.vue?vue&type=style&index=1&id=7d7c5d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7c5d56",
  null
  
)

export default component.exports